import React, { useState, useEffect, useRef } from "react";
import classes from './PaymentInstruction.module.css';
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings
} from 'lucide-react';
import Footer from "../../Accoungting/Footer/Footer";
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../../../Components/Styles/API/API';
import { ToWords } from 'to-words';
import { usePDF } from "react-to-pdf";
import { FcPrint } from "react-icons/fc";
import { OverlayTrigger, Tooltip } from "react-bootstrap";



const PaymentInstructions = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Get customer data from navigation state
    const supplierName = location.state?.customerName || "Supplier Name"; // Keep as customerName for now since that's what you're passing
    const supplierId = location.state?.customerId || null;
    const supplierDetails = location.state?.customerDetails || null;
    const filteredTransactions = location.state?.filteredInvoices || []; // These are actually supplier ledger entries
    const totalPurchases = location.state?.totalSales || 0; // Total purchases from supplier
    const totalPaid = location.state?.totalPaid || 0;
    const totalOutstanding = location.state?.totalOutstanding || 0;
    const totalInvoices = location.state?.totalInvoices || 0;
    const [bearer, setBearer] = useState('');
    const [continent, setContinent] = useState('');
    const [region, setRegion] = useState('');
    const [province, setProvince] = useState('');
    const [userType, setUserType] = useState('');
    const [instructionLoading, setInstructionLoading] = useState(false);
    const [company, setCompany] = useState('');

    // Convert invoice data to ledger entries
    const [ledgerData, setLedgerData] = useState([]);
    const { rowsToPass, selectedBank, selectedDate, selectedBankName, selectedBankAc  } = location.state;
    const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
        name: 'Naira',
        plural: 'Naira',
    //   name: vouchers?.vouchers[0]?.currency?.currency,
    //   plural: vouchers?.vouchers[0]?.currency?.currency,
    //   symbol: vouchers?.vouchers[0]?.currency?.symbol,
        fractionalUnit: {
        name: 'Kobo',
        plural: 'Kobo',
        // symbol: '',
        },
    }
    }
    });


     const [printed, setPrinted] = useState(false);

     const [showEmailModal, setShowEmailModal] = useState(false);
       const [email, setEmail] = useState("");
       const printRef = useRef();
     
        const { toPDF, targetRef } = usePDF({
         filename: "payment_instruction.pdf",
       });


           const readData = async () => {
             try {
               const value = localStorage.getItem('userToken');
               const value1 =  localStorage.getItem('companyName');
               const continentName =  localStorage.getItem('continent');
                 const regionName =  localStorage.getItem('region');
                 const provinceName =  localStorage.getItem('province');
                const admins =  localStorage.getItem('admin');
         
               if (value !== null) {
                 setBearer(value);
                 // setAuthenticated(true);
               }
               if (value1 !== null) {
                 setCompany(value1);
              
               }
               if (continentName !== null) {
                 setContinent(continentName);
             }
             if (regionName !== null) {
                 setRegion(regionName);
             }
             if (provinceName !== null) {
                 setProvince(provinceName);
             }
             if (admins !== null) {
               setUserType(admins);
           }
             } catch (e) {
               alert('Failed to fetch the input from storage');
             }
           };
       
           useEffect(() => {
             readData();
       
         }, []);
       

const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
};
     
  const generateCurrentDate = () => {
    const currentDate = new Date();
    
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = currentDate.getFullYear();
  
    const formattedDate = `${day}-${month}-${year}`;
    
    return formattedDate;
  };

  const currentDate = generateCurrentDate();
    const total = rowsToPass.reduce((acc, item) => acc + parseFloat(item.amountToPay ?? item.balance), 0);


const handlePrintNew = async () => {
   if (printed) {
      window.print();
      return;
    }
  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to print this instruction?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Print",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Show loading Swal
      Swal.fire({
        title: "Please wait",
        text: "Your instruction is being processed for printing...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const ids = rowsToPass.map((row) => row.id);
      const amounts = rowsToPass.map((row) => row?.amount);

      console.log(amounts);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/pay-payables`,
          {
            payable_id: ids,
            payment_bank: selectedBank,
            amount: amounts,
            // payment_description: description,
          },
          { headers }
        );

        Swal.close();

      
setPrinted(true);
 setTimeout(() => {
      window.print();
    }, 300); 
      } catch (error) {
        Swal.close();

        let errorMessage = "An error occurred. Please try again.";
        if (error.response?.data?.message) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.error(error);
      }
    }
  });
};
  

    // Helper functions for currency formatting
    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
    };

    const getPaymentStatus = (debtAmount, totalAmount) => {
        const debtNum = parseFloat(debtAmount || 0);
        const totalNum = parseFloat(totalAmount || 0);

        if (debtNum === 0) {
            return "Paid";
        } else if (debtNum === totalNum) {
            return "Owing";
        } else {
            return "Partial";
        }
    };

    const handlePrint = () => window.print();



    useEffect(() => {
        // Transform supplier ledger data to personal ledger entries
        if (filteredTransactions && filteredTransactions.length > 0) {
            const transformedData = filteredTransactions.map((transaction, index) => {
                const totalAmount = parseFloat(transaction.balance || transaction.amount || 0);
                const debitAmount = parseFloat(transaction.debit || 0);
                const creditAmount = parseFloat(transaction.credit || 0);

                // For suppliers: debit = what we owe them, credit = what we paid them
                return {
                    id: transaction.id || `${index}`,
                    date: transaction.transaction_date || transaction.created_at?.split("T")[0] || new Date().toISOString().split("T")[0],
                    ref: transaction.invoice_number || transaction.uuid || `REF-${transaction.id || index}`,
                    description: transaction.description || 'Supplier Transaction',
                    account: '2100-Accounts Payable', // Changed from Receivable to Payable for suppliers
                    debit: debitAmount > 0 ? formatMoney(debitAmount) : '',
                    credit: creditAmount > 0 ? formatMoney(creditAmount) : '',
                    balance: formatMoney(totalAmount),
                    type: 'supplier_transaction',
                    rawDebit: debitAmount,
                    rawCredit: creditAmount,
                    rawBalance: totalAmount
                };
            });

            // Sort by date
            const sortedData = transformedData.sort((a, b) => new Date(a.date) - new Date(b.date));
            setLedgerData(sortedData);
        } else {
            // Fallback to supplier details ledgers if available
            if (supplierDetails && supplierDetails.ledgers) {
                const transformedLedgers = supplierDetails.ledgers.map((ledger, index) => ({
                    id: ledger.id || index,
                    date: ledger.transaction_date || ledger.created_at?.split("T")[0] || new Date().toISOString().split("T")[0],
                    ref: ledger.reference || ledger.invoice_number || ledger.uuid || `REF-${ledger.id || index}`,
                    description: ledger.description || 'Supplier Transaction',
                    account: '2100-Accounts Payable',
                    debit: ledger.debit ? formatMoney(ledger.debit) : '',
                    credit: ledger.credit ? formatMoney(ledger.credit) : '',
                    balance: formatMoney(ledger.balance || 0),
                    type: 'ledger',
                    rawDebit: parseFloat(ledger.debit || 0),
                    rawCredit: parseFloat(ledger.credit || 0),
                    rawBalance: parseFloat(ledger.balance || 0)
                }));
                setLedgerData(transformedLedgers);
            }
        }
    }, [filteredTransactions, supplierDetails]);


    const [selectedRows, setSelectedRows] = useState([]);
    const allSelected = selectedRows.length === ledgerData.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(ledgerData.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter(i => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // Calculate running balance
    // (For suppliers: debit increases what we owe, credit decreases what we owe)
    let runningBalance = 0;
    const dataWithRunningBalance = ledgerData.map(row => {
        const debitAmount = row.rawDebit || parseFloat(row.debit.replace(/,/g, '') || 0);
        const creditAmount = row.rawCredit || parseFloat(row.credit.replace(/,/g, '') || 0);

        // For suppliers: debit increases liability, credit decreases liability
        runningBalance += debitAmount - creditAmount;

        return {
            ...row,
            runningBalance: formatMoney(Math.abs(runningBalance))
        };
    });

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                {/* Action Buttons */}
                <div className={classes.actions}>
                    <button className={classes.btns} onClick={() => navigate("/transactions/receivables/sales")}>
                        New Sales Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}>
                        New Purchase Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/customer-sales")}>
                        All Invoices
                    </button>
                    <button className={`${classes.btns} ${classes.greens}`} onClick={() => navigate("/settings/product-services")}>
                        Product & Services
                    </button>
                </div>

                {/* Form and Icons */}
                <div className={classes.act}>
                    <form className={classes.form}>
                        <div className={classes.group}>
                            <label>Period:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>Current month</option>
                                    <option>Last month</option>
                                    <option>This year</option>
                                    <option>Custom range</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>

                        <div className={classes.group1}>
                            <label>Group by:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>None</option>
                                    <option>Date</option>
                                    <option>Transaction Type</option>
                                    <option>Amount</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>
                        {/* <div className={classes.group1}>
                            <label>Start Date:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>01/01/25</option>
                                    <option>01/12/24</option>
                                    <option>01/11/24</option>
                                    <option>01/10/24</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>
                        <div className={classes.group1}>
                            <label>End Date:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>{new Date().toLocaleDateString('en-GB')}</option>
                                    <option>31/12/24</option>
                                    <option>30/11/24</option>
                                    <option>31/10/24</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div> */}

                        <div className={classes.group1}>
                            <button className={classes.greenBtn} type="button">
                                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                                Run Report
                            </button>
                        </div>
                    </form>

                    <div className={classes.iconbars}>
                        <div className={classes.iconbarr}>
                            <div className={classes.iconbar}>
                                <Filter size={16} style={{ marginRight: "6px" }} />
                                Filter
                            </div>
                            <div className={classes.iconbar}>
                                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                                Schedule
                            </div>
                        </div>

                        <div className={classes.iconbarss}>
                            <div className={classes.iconbar}>
                                <Mail size={16} />
                            </div>
                            <div className={classes.iconbar} style={{ cursor: "pointer" }} 
                            onClick={handlePrintNew}
                            >
                                <Printer size={16} />
                            </div>
                            <div className={classes.iconbar}>
                                <Download size={16} />
                            </div>
                            <div className={classes.iconbar}>
                                <Settings size={16} />
                            </div>
                        

                        </div>
                    </div>
                </div>

                {/* Back Button */}
                <div className={classes.matron}>
                    <div>
                        <button
                            className={classes.backButton}
                            onClick={() => navigate(-1)}
                        >
                            <ArrowLeft size={16} style={{ marginRight: '6px' }} />
                        </button>
                    </div>

                    <div>
                        <p className={classes.toplea}>Payment Instruction</p>
                        {/* <p className={classes.topl}>Financial position as of {new Date().toLocaleDateString()}</p> */}
                    </div>
                </div>

                {/* Customer Summary Cards */}

                {/* Report Content */}
                <div className={classes.containere}>
                    {/* <header className={classes.headers}>
                        <h1 className={classes.companyName}>REDEEMED CHRISTIAN CHURCH OF GOD</h1>
                        <h2 className={classes.title}>PAYMENT INSTRUCTION</h2>
                        <p className={classes.toplea}>
                            {supplierName}'s Personal Ledger
                        </p>
                        <button className={classes.unaudited}>unaudited</button>
                    </header> */}

                    <div className={classes.address}>
                    <p style={{fontSize: 15, color: '#000000'}}>
                        <strong>To:</strong>
                        <br />
                        The Branch Manager, <br /> {selectedBankName}.
                    </p>

                    <p style={{fontSize: 15, color: '#000000'}}>
                        {/* Place: */}
                        <br /> Date: {currentDate}
                    </p>
                    </div>

                    {/* <p style={{ textAlign: "center", color: '#000000' }}>
                    Subject: <strong>{description}</strong>
                    </p> */}

                    <p style={{fontSize: 15, color: '#000000'}}>Dear Sir/Madam,</p>

                    <p style={{fontSize: 15, color: '#000000'}}>
                    {/* <span> We</span>{" "} */}
                    <strong>We The Redeemed Christian Church of God</strong> request you to Kindly transfer the
                    amount to the following beneficiaries to their respective bank
                    accounts by debiting from our account bearing a/c no.{" "}
                    <strong>{selectedBankAc}</strong>.
                    </p>

                    <div className={classes.divider}></div>

                    {/* Table Container */}
                    <div className={classes.tableContainer}>
                        <table className={classes.table}>
                            <thead>
                                <tr className={classes.tableHeader}>
                                    <th>S/N</th>
                                    <th>Account Name</th>
                                    <th>Bank</th>
                                    <th>Account No.</th>
                                    <th style={{textAlign: 'right'}}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rowsToPass?.map((row, index) => (
                                    <tr key={row.id || index} className={classes.tableRow}>
                                        <td className={classes.tableCell}>{index + 1}</td>
                                        <td className={classes.tableCell}>{row.supplier?.account_name || row.customer?.account_name}</td>
                                        <td className={classes.tableCell}>{row.supplier?.bank_name || row.customer?.bank_name}</td>
                                        <td className={classes.tableCell}>{row.supplier?.account_number || row.customer?.account_number}</td>
                                        <td style={{ color: 'rgba(22, 163, 74, 1)', textAlign: 'right' }}>
                                        {parseFloat(row.amountToPay ?? row.balance).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}                                        
                                        </td>
                                        {/* <td style={{ textAlign: 'right' }}>₦{row.runningBalance}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                            <div style={{marginTop: '2rem'}} />
                            <tr >
                                <td style={{ textAlign: "left", fontSize: 15 }}>
                                <strong>Total</strong>
                                </td>
                                <td colSpan="3" style={{width: "70%", fontWeight: 500, fontSize: 15}}>

                                {total ? toWords.convert(parseFloat(total)) : ''}
                                </td>

                                <td style={{ textAlign: "right", fontWeight: "bold", fontSize: 15 }}>{total.toLocaleString('en-US', {
                                    minimumIntegerDigits: 1,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}</td>
                            </tr>
                            <tr>
                            </tr>
                        </table>
                    </div>

<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '5rem' }}>
                    <p style={{borderTop: '1px solid black'}}>Prepared By:</p>
                    <p style={{borderTop: '1px solid black'}}>Authorized Signature:</p>
</div>
                    {/* Summary Footer */}

                    {/* Footer Table */}
                    {/* <table className={classes.footerTable}>
                        <tfoot>
                            <tr>
                                <td className={classes.frston}>First</td>
                                <td className={`${classes.page} ${classes.activePage}`}>1</td>
                                <td className={classes.twono}>2</td>
                                <td className={classes.lastno}>Last</td>
                            </tr>
                        </tfoot>
                    </table> */}

                    {/* <div className={classes.lasone}>
                        <div className={classes.paginationDisplay}>
                            Displaying 1 - {dataWithRunningBalance.length} of {dataWithRunningBalance.length}
                        </div>
                    </div> */}
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
};

export default PaymentInstructions;